module.exports = __webpack_public_path__ + "static/media/aces_c2_off.364f1519.svg";